import { render } from "./BugReport.vue?vue&type=template&id=c4ed1814&scoped=true"
import script from "./BugReport.vue?vue&type=script&lang=js"
export * from "./BugReport.vue?vue&type=script&lang=js"

import "./BugReport.vue?vue&type=style&index=0&id=c4ed1814&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ed1814"]])

export default __exports__